module.exports = __webpack_public_path__ + "media/transaction.9817d55f.mp3";